import React from 'react';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';

import {
  SearchKit,
  SearchLoadMore,
} from '@uncinc/uncinc-react-kitchen-sink';

import VolunteerWorkSearchBar from '../../components/VolunteerWorkSearch/Searchbar';
import VolunteerWorkSearchResults from '../../components/VolunteerWorkSearch/Results';

import * as query from './query.graphql';

import './style.scss';

const VolunteerWork = () => {
  const { t } = useTranslation();

  return (
    <div className="VolunteerWorkPage">
      <SearchKit
        uri={config.get('APOLLO_SEARCH_URL')}
        query={query}
        pageSize={6}
        defaultSorting="relevance"
        useRouting={false}
      >
        {
          (data, loading) => {
            if (!data) {
              return;
            }

            return (
              <div className="VolunteerWorkSearch">
                <VolunteerWorkSearchBar />
                <VolunteerWorkSearchResults data={data.nLDoetVolunteerWorkSearch} />
                <SearchLoadMore
                  className="VolunteerWorkSearch__showmore"
                  data={data.nLDoetVolunteerWorkSearch}
                  label={t('show_more')}
                />
              </div>
            );
          }
        }
      </SearchKit>
    </div>
  );
};

export default VolunteerWork;
